<template>
  <div class="part6">
    <div class="partBox">
      <div class="camp pr">
        <div
          v-for="(item, index) in imgList"
          :key="index"
          class="campbox"
          :class="{ active: index === roleItem }"
        >
          <img class="w100" :src="item" alt="" />
        </div>
      </div>
      <!-- 头像 -->
      <!-- <div class="role_nav dl">
      <div
        v-for="(role, index) in imgList2"
        :key="index"
        class="role_navbx"
        :class="{ activeHead: index === roleItem }"
        @click="mouseenter(index)"
        @mouseenter="mouseenter(index)"
        @mouseleave="mouseleave(index)"
      >
        <img :src="role" alt="" />
      </div>
    </div> -->
      <!-- 左右按钮 -->
      <p class="next pa gong" @click="nextone">
        <img src="../assets/images/arrows_right.png" alt="" />
      </p>
      <p class="prev pa gong" @click="prevone">
        <img src="../assets/images/arrows_left.png" alt="" />
      </p>
      <!-- <div class="p_btn mt dl">
      <p class="Btn">转职立绘</p>
      <p class="Btn">转职立绘</p>
    </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "pageSix",
  data() {
    return {
      imgList: [
        require("@/assets/images/page6/introduction2.png"),
        require("@/assets/images/page6/introduction1.png"),
        require("@/assets/images/page6/introduction3.png"),
        require("@/assets/images/page6/introduction4.png"),
      ],
      imgList2: [
        require("@/assets/images/page6/title2.png"),
        require("@/assets/images/page6/title1.png"),
        require("@/assets/images/page6/title3.png"),
        require("@/assets/images/page6/title4.png"),
      ],
      roleItem: 0,
      timer: null,
      autoCarousel: true,
      deviceType: "",
    };
  },
  created() {},
  mounted() {
    // this.Carousel();
    this.$bus.$on("point5", () => {
      this.anchor();
    });
    if (this.$util._isMobile()) {
      // alert("移动端");
      let type = document.getElementsByClassName("camp ")[0];
      type.style.height = 8.5 + "rem";
    } else {
      // let type = document.getElementsByClassName("camp ")[0];
      // type.style.height = 10 + "rem";
      // alert("pc端");
    }
  },
  methods: {
    //定位
    anchor() {
      let ele = document.getElementsByClassName("part6")[0];
      let eletop = ele.offsetTop;
      window.scrollTo({
        top: eletop,
        behavior: "smooth",
      });
    },
    //自动轮播
    Carousel() {
      // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
      clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        if (this.autoCarousel) {
          this.roleItem++;
          if (this.roleItem == this.imgList.length) {
            this.roleItem = 0;
          }
        }
      }, 2000);
    },
    // 鼠标移入头像 停止自动轮播
    mouseenter(index) {
      if (this.roleItem === index) return;
      this.autoCarousel = false;
      setTimeout(() => {
        this.roleItem = index;
      }, 200);
    },
    // 鼠标移出头像 继续自动轮播
    mouseleave() {
      this.autoCarousel = true;
      this.Carousel();
    },
    //下一个
    nextone() {
      if (this.roleItem == this.imgList.length - 1) {
        this.roleItem = 0;
      } else {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.roleItem++;
        }, 100);
      }
    },
    // 上一个
    prevone() {
      if (this.roleItem == 0) {
        this.roleItem = this.imgList.length - 1;
      } else {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.roleItem--;
        }, 100);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.part6 {
  width: 100%;
  position: relative;
  .partBox {
    padding-top: 2rem;
    .camp {
      width: 95%;
      height: 8.5rem;
      margin: 0 auto;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: url("../assets/images/page6/page6before.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 86%;
      }
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: url("../assets/images/page6/page6after.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 86%;
      }
      .campbox {
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        right: 0;
        opacity: 0;
        transition: 0.3s all ease-in-out;
        img {
          height: 107%;
          width: 110%;
          top: 0.35rem;
          position: absolute;
          left: -0.65rem;
        }
        &.active {
          // transform: translateX(0%);
          opacity: 1;
        }
      }
    }
    // .p_btn {
    //   justify-content: center;
    //   width: 100%;
    //   bottom: 1rem;
    //   .Btn {
    //     width: 2.5rem;
    //     height: 0.8rem;
    //     line-height: 0.8rem;
    //     border: 1px solid #000;
    //     margin-right: 0.5rem;
    //     font-size: 0.3rem;
    //     white-space: nowrap;
    //     background: aquamarine;
    //     &:nth-of-type(2) {
    //       margin-right: 0;
    //     }
    //   }
    // }
    .role_nav {
      justify-content: center;
      gap: 0.3rem;
      margin-bottom: 0.5rem;
      .role_navbx {
        width: 1.5rem;
        height: 1.5rem;
        transition: 0.3s all ease-in-out;
        position: relative;
        top: 0;
        img {
          height: 100%;
        }
        &.activeHead {
          transform: scale(1.1);
          top: -0.2rem;
        }
      }
    }
    .gong {
      top: 50%;
      height: 1rem;
      width: 0.82rem;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .next {
      right: 0.05rem;
    }
    .prev {
      left: 0rem;
    }
  }
}
</style>